export const Button_Types = Object.freeze ({
    Disabled: 'Disabled',
    Regular: 'Regular',
    Destructive_Action: 'Destructive_Action',
    Approved: 'Approved',
    Removed: 'Removed',
})